// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Z8nV","left":"styles_left__10d2M"};